module.exports = __webpack_public_path__ + "static/media/IMG_4478a.d47ee47b.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/lostWorld/IMG_4478a.JPG
// module id = 172
// module chunks = 0